import ReactGA from "react-ga4";
export const BASE_URL = process.env.REACT_APP_BASE_URL;
export const CAPCH_KEY= process.env.REACT_APP_CAPCH_KEY;
export const ReactGAs=ReactGA.initialize("G-J5H5084J8F");

